<template>
    <div class="error-container">
        <h3><slot name="Title">An error occured</slot></h3>
        <h4><slot name="SubTitle"></slot></h4>
        <p><slot name="Content">An error occured while processing your request. We are sorry for that.</slot></p>
        <div class="actions"><slot name="Actions"></slot></div>
    </div>
</template>

<script>
    export default {
        name: 'ErrorPage'
    }
</script>

<style scoped>
    .error-container {
        text-align: center;
        max-width: 400px;
        margin: auto;
        width: 400px;
        /*border: 1px solid rgba(0,0,0,0.05);*/
    }

    h3 {
        color: #292C33;
        font-size: 18px;
        font-weight: 600;
        line-height: 22px;
        margin: 20px 0;
    }

    h4 {
        color: #292C33;
        font-size: 14px;
        font-weight: bold;
        line-height: 22px;
    }

    p {
        color: #292C33;
        font-family: "Proxima Nova";
        font-size: 14px;
        letter-spacing: 0.54px;
        line-height: 22px;
        text-align: center;
    }

    .actions {
        padding: 10px 0;
    }
</style>